export const MetricIdSeperator: string = '-->';
